// extracted by mini-css-extract-plugin
export var container = "style-module--container--GIH2V";
export var icon = "style-module--icon--sSn81";
export var imglyTypoButton = "style-module--imgly--typo-button---HR8l";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--zMlez";
export var imglyTypoH1 = "style-module--imgly--typo-h1--wMVkr";
export var imglyTypoH2 = "style-module--imgly--typo-h2--3oUhH";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--ZuyDz";
export var imglyTypoH3 = "style-module--imgly--typo-h3--5oWdE";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--ugwzC";
export var imglyTypoH4 = "style-module--imgly--typo-h4--j5VpC";
export var imglyTypoH5 = "style-module--imgly--typo-h5--98Kc4";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--ysgJU";
export var imglyTypoIcon = "style-module--imgly--typo-icon--vX9Bz";
export var imglyTypoLink = "style-module--imgly--typo-link--tSyxs";
export var imglyTypoOverline = "style-module--imgly--typo-overline--d7vEU";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--IqdRR";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--OuvXs";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--U+YK6";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--pjzmA";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--ka8Iv";
export var imglyTypoSubline = "style-module--imgly--typo-subline--qPt7O";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--etrD2";
export var link = "style-module--link--tTdA-";
export var naviLabelIsLarge = "style-module--navi-label-is-large--y042V";
export var naviLabelIsSmall = "style-module--navi-label-is-small--aHblC";
export var root = "style-module--root--vCeS8";
export var text = "style-module--text--BbJbi";